/**
 * GameEffectNWScriptEffectType enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file GameEffectNWScriptEffectType.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum GameEffectNWScriptEffectType {
  EffectInvalidEffect =		undefined as any,
  EffectDamageResistance =	1,
  //EFFECT_TYPE_ABILITY_BONUS =		2,
  EffectRegenerate =	      3,
  //EFFECT_TYPE_SAVING_THROW_BONUS =		4,
  //EFFECT_TYPE_MODIFY_AC =		5,
  //EFFECT_TYPE_ATTACK_BONUS =		6,
  EffectDamageReduction =		7,
  //EFFECT_TYPE_DAMAGE_BONUS =		8,
  EffectTemporaryHitPoints =		9,
  //EFFECT_TYPE_DAMAGE_IMMUNITY =		10,
  EffectEntangle =		      11,
  EffectInvulnerable =		  12,
  EffectDeaf =		          13,
  EffectRessurection =		  14,
  EffectImmunity =		      15,
  //EFFECT_TYPE_BLIND =		16,
  EffectEnemyAttackBonus =	17,
  EffectArcaneSpellFailure =		18,
  //EFFECT_TYPE_MOVEMENT_SPEED =		19,
  EffectAreaOfEffect =		  20,
  EffectBeam =             21,
  //EFFECT_TYPE_FORCE_RESISTANCE =		22,
  EffectCharmed =	        23,
  EffectConfused =	        24,
  EffectFrightened =	      25,
  EffectDominated =      	26,
  EffectParalyze =	        27,
  EffectDazed =	          28,
  EffectStunned =	        29,
  EffectSleep =	          30,
  EffectPoison =	          31,
  EffectDisease =	        32,
  EffectCurse =	          33,
  EffectSilence =	        34,
  EffectTurned =	          35,
  EffectHaste =	          36,
  EffectSlow =	            37,
  EffectAbilityIncrease =  38,
  EffectAbilityDecrease =  39,
  EffectAttackIncrease =   40,
  EffectAttackDecrease =   41,
  EffectDamageIncrease =   42,
  EffectDamageDecrease =   43,
  EffectDamageImmunityIncrease =   44,
  EffectDamageImmunityDecrease =   45,
  EffectACIncrease =       46,
  EffectACDecrease =       47,
  EffectMovementSpeedIncrease =    48,
  EffectMovementSpeedDecrease =    49,
  EffectSavingThrowIncrease =      50,
  EffectSavingThrowDecrease =      51,
  EffectForceResistanceIncrease =  52,
  EffectForceResistanceDecrease =  53,
  EffectSkillIncrease =		54,
  EffectSkillDecrease =		55,
  EffectInvisibility =			56,
  EffectImprovedInvisibility =			57,
  EffectDarkness =			    58,
  EffectDispellMagic =			59,
  EffectElementalShield =	60,
  EffectNegativeLevel =		61,
  EffectDisguise =			    62,
  EffectSanctuary =			  63,
  EffectTrueseeing =			  64,
  EffectSeeInvisible =			65,
  EffectTimeStop =			    66,
  EffectBlindness =			  67,
  EffectSpellLevelAbsorption =			68,
  EffectDispellMagicBest =	69,
  EffectUltraVision =			70,
  EffectMissChance =			  71,
  EffectConealment =			  72,
  EffectSpellImmunity =		73,
  EffectAssuredHit =       74,
  EffectVisualEffect =     75,
  EffectForcePushed =      80,
  EffectFeat =             83,
}
